import mergeModuleConfigs from 'core/utils/mergeModuleConfigs';
import { instoreEducationalTile as orgModuleConfig } from 'org/configs/modules.config';

import orgConfig from 'org/configs/org.config';

const { instoreLabel } = orgConfig;

const defaultConfig = {
  defaults: {
    addCardInstoreLabel: instoreLabel,
    linkOffersInstoreLabel: instoreLabel,
  },
};

export default mergeModuleConfigs(defaultConfig, orgModuleConfig);
